import React, { useState } from "react";
import { BrowserRouter, Route, Redirect, Switch } from "react-router-dom";
import ProtectedRoute from "./components/Routing/index";
import {Modal} from 'antd';
import "./App.css";
import Api from "./components/APIS/Api";

const Login = React.lazy(() => import("./components/loginpage/index"));
const Requests = React.lazy(() => import("./components/requests/index"));
const Jobs = React.lazy(() => import("./components/jobs/index"));
const NewJobs = React.lazy(() => import("./components/newJobs/index"));
const EditJob = React.lazy(() => import("./components/editJob/index"));
const Job = React.lazy(() => import("./components/job/index"));




function App() {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [auth, setAuth] = useState(null);
  const [canBlock , setCanBlock] = useState(false)
  const setItemInLocal = (item: {code: number, identifier: number, token: string, message: string}) => {
    
    const data = {
      identifier: item.identifier,
      token: item.token,
      message: item.message,
    };
    localStorage.setItem("oddruN@2021%", JSON.stringify(data));
    setAuth(JSON.parse(localStorage.getItem("oddruN@2021%")));
  };


  const getConfirm = (content: string, callback: (arg:boolean)=> void) => {
    Modal.confirm({
      className:'prevent-modal', 
        title: 'فرصت شغلی ذخیره شود ؟',
      content ,
      okText:'ذخیره فرصت شغلی',
      cancelText:'بیخیال',
      onOk: () => {
        Api.addOrEditFromPromp(JSON.parse(localStorage.getItem("editAddValue")))
        .then(response=>{if(response.status===200){
          callback(true)
          return response.data
        }}).catch(()=>console.error())
         
      },
      onCancel: () => {
          setCanBlock(true)
          callback(false);
      }
  })

  };
const parentCallBack = (setIsBlocking: (arg: boolean)=> void) => {
  if(canBlock){
    setIsBlocking(false)
  }
}

  return (
    <React.Suspense fallback={<span />}>
      <BrowserRouter getUserConfirmation={getConfirm}>
        <Switch>
          <Route exact path="/" render={() => <Redirect to="/requests" />} />
          <Route
            exact
            path="/login"
            render={(props) => <Login {...props} local={setItemInLocal} />}
          />
          <ProtectedRoute
            exact
            path="/requests"
            component={(props) => <Requests {...props} />}
          />
          <ProtectedRoute
            exact
            path="/jobs"
            component={(props) => <Jobs {...props} />}
          />
          <ProtectedRoute
           parentCallBack={parentCallBack}
           setCanBlock={setCanBlock}
            exact
            path="/new-jobs"
            component={(props) => <NewJobs {...props} />}
          />

          <ProtectedRoute
           parentCallBack={parentCallBack}
           setCanBlock={setCanBlock}
            exact
            path="/edit-job"
            component={(props) => <EditJob {...props} />}
          />

          <ProtectedRoute
            exact
            path="/job"
            component={(props) => <Job {...props} />}
          />
        </Switch>
      </BrowserRouter>
    </React.Suspense>
  );
}

export default App;
